import React from 'react';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { ImmutableGenericBlockEntity } from '..';

interface Props {
  entity: ImmutableGenericBlockEntity;
}

const BlockText: React.FC<Props> = ({ entity }) => (
  <WysiwygField
    property="schema:text"
    className="TextBlock"
    html={entity.getIn(['body', 0, 'processed'])}
  />
);

export default BlockText;
